/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Типы заявок на отпуск
 */
export enum VacationApplicationType {
    PAID = 'paid',
    UNPAID = 'unpaid',
}
